import { leftSpout, rightReceptacle, MID_ROW, type LevelConfig } from './portHelpers';

export const LEVEL_3: LevelConfig = {
  step: 3,
  title: 'STEP THREE',
  instructions:
    'Drag the brain into the workspace. Feed it nutrients + oxygen from the left. The brain consumes them and releases CO₂ waste — route that to the right.',
  ports: [
    // v5.2: wall spout no longer carries CO₂ — brain produces CO₂ as a
    // metabolic byproduct (matches the organ rules CSV).
    leftSpout('s3-spout-blood', MID_ROW, ['food', 'oxygen']),
    rightReceptacle('s3-recept-CO2', MID_ROW, ['co2']),
  ],
  organPool: [
    {
      id: 'brain',
      art: 'brain',
      cols: 3,
      rows: 3,
      // v5.2: brain pulses when its output is emitting CO₂ — i.e., when food
      // and oxygen have arrived correctly at the input. Replaces the legacy
      // `LevelConfig.activationPortId` mechanism.
      activatesWhen: ['s3-brain-out'],
      ports: [
        // Left input: one cell west of the organ, middle row.
        {
          id: 's3-brain-in',
          kind: 'receptacle',
          facing: 'W',
          cellOffset: { dCol: -1, dRow: 1 },
          carries: ['food', 'oxygen'],
        },
        // Right output: emits CO₂ when the input is correctly receiving
        // food+oxygen. Brain consumes those internally — the CSV says so.
        {
          id: 's3-brain-out',
          kind: 'spout',
          facing: 'E',
          cellOffset: { dCol: 3, dRow: 1 },
          carries: ['co2'],
          dependsOn: ['s3-brain-in'],
        },
      ],
    },
  ],
};
